<template>
<div>
  <div title="Actions" v-if="chooseImage" icon="feather icon-settings">
          <div
            v-html="content"
            class="text-center previewed_action_holder"
            :style="{ backgroundImage: 'url(' + chooseImage.file.file_path + ')' }"
          ></div>
        </div>
          <div title="Actions" v-else icon="feather icon-settings">
          <div
            v-html="content"
            class="text-center previewed_action_holder"
          ></div>
        </div>
</div>

</template>
<script>
export default {
  data () {
    return {
     //chooseImage:'https://scoolio-files.s3.ap-south-1.amazonaws.com/20210623105126434008/Default/ZDPYlWOpThDzIJqN.jpeg'
    }
  },
  props:{
    content:{},
    chooseImage:{},
  }
}
</script>
<style>
.invoice_preview_card {
  padding: 15px;
}
.invoice_preview_card .vs-card--content {
  font-size: 14px;
}
</style>